import React, {useState, useEffect} from 'react';
import {useGetDepartmentsQuery} from '../../../data/api';
import SettingsTable from './SettingsTable';
import {departmentColumns} from '../../../constants';

const Departments = () => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [fetchedDepartments, setFetchedDepartments] = useState([]);
  const [paginationId, setPaginationId] = useState(0);
  const {data, isSuccess, isFetching, isError} = useGetDepartmentsQuery({
    paginationId,
    limit: 100,
  });

  useEffect(() => {
    if (isSuccess) {
      setFetchedDepartments(data);
      if (isFirstRender) {
        // only set total rows on first render
        setTotalRows(data[0].total_count);
        setIsFirstRender(false);
      }
    }
  }, [data, isSuccess]);
  return (
    <SettingsTable
      isFetching={isFetching}
      isError={isError}
      tableData={fetchedDepartments}
      totalRows={totalRows}
      tableHeaders={departmentColumns}
      pageTitle={'Departments'}
      badgeTitle={'departments'}
      setPaginationId={setPaginationId}
    />
  );
};

export default Departments;
